import styled from '@emotion/styled'
import { FormControlLabel } from '@mui/material'

export const ColumnContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 8rem;
`

export const StyledFormControlLabel = styled(FormControlLabel)`
    margin: 0;
`
